module.exports = __webpack_public_path__ + "assets/img/customerService-a0b19bbf.png";